var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  Errors: () => Errors
});
var Errors;
(function(Errors2) {
  Errors2[Errors2["invalidValue"] = 1001] = "invalidValue";
  Errors2[Errors2["invalidType"] = 1002] = "invalidType";
  Errors2[Errors2["questionCannotBeValidated"] = 1003] = "questionCannotBeValidated";
  Errors2[Errors2["questionHasNoSubquestions"] = 1004] = "questionHasNoSubquestions";
  Errors2[Errors2["questionCannotHaveValue"] = 1005] = "questionCannotHaveValue";
  Errors2[Errors2["questionCannotHaveOptions"] = 1006] = "questionCannotHaveOptions";
  Errors2[Errors2["subquestionCannotHaveValue"] = 1007] = "subquestionCannotHaveValue";
  Errors2[Errors2["questionCannotBeCreatedOutsideDende"] = 1008] = "questionCannotBeCreatedOutsideDende";
  Errors2[Errors2["subquestionCannotBeCreatedOutsideDende"] = 1009] = "subquestionCannotBeCreatedOutsideDende";
  Errors2[Errors2["subquestionCannotHaveOptions"] = 1010] = "subquestionCannotHaveOptions";
  Errors2[Errors2["yayoyakiCannotHaveValue"] = 2001] = "yayoyakiCannotHaveValue";
})(Errors || (Errors = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Errors
});
